import { Form, FormField, FormRepeaterItem } from '@/libs/form'
import { computed, watch } from 'vue'

export class PhoneNumberForm extends Form {
    compose () {
        this.addField(new FormField('phoneNumber', {
            label: 'common.phone-number.phone-number',
            inputType: 'text',
            validators: [
                { 'type': 'required' },
            ],
        }))

        this.addField(new FormField('category', {
            label: 'common.term.category',
            inputType: 'phoneNumberCategory',
            validators: [
                { type: 'required' },
            ],
        }))

        this.addField(new FormField('label', {
            label: 'common.term.label',
            inputType: 'phoneNumberLabel',
            props: {
                filter: computed(() => {
                    const filter = {}
                    if (this.getItem('category').value !== null) filter.filterCategoryIds = [this.getItem('category').value]
                    return filter
                }),
            },
            attributes: {
                disable: computed(() => {
                    return this.getItem('category').value === null
                }),
            },
        }))
        watch(() => this.getItem('category').value, (newValue, oldValue) => {
            if (oldValue !== null) this.getItem('label').resetValue()
        })

        this.addField(new FormField('isMain', {
            label: 'common.contact.main-phone-number',
            inputType: 'checkbox',
            attributes: {
                disable: false,
            },
        }))
    }
}


export class PhoneNumberRepeaterItem extends FormRepeaterItem {
    compose () {
        const form = new PhoneNumberForm({ excludeItems: ['isMain'] })
        this.addItems(form.items)
    }
}

